import styled from "styled-components";


export const ComponentBaseContainer = styled.div`
    height:90vh;
    display:flex;
    color:white;
    align-items:center;
    margin:10px;
    padding:10px;
    

.jwt-header-highlight {
position: absolute;
  background-color: rgba(33, 150, 243, 0.2); /* Blue */
}

.jwt-payload-highlight {
position: absolute;
  background-color: rgba(76, 175, 80, 0.2); /* Green */
}

.jwt-signature-highlight {
position: absolute;
  background-color: rgba(244, 67, 54, 0.2); /* Red */
}
`;